import parse from 'csv-parse/lib/sync';

// eslint-disable-next-line import/prefer-default-export
export const csvParser = (csvConfig) => (fileData) => parse(fileData, csvConfig);
